import { useState } from "react";
import Drawer from "@mui/material/Drawer";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import "./styles.css";
import { Switch } from "@mui/material";

export default function MobileDrawer() {
    const [open, setOpen] = useState(false);
    const setDark = () => {
        localStorage.setItem("theme", "dark");
        document.documentElement.setAttribute("data-theme", "dark");
    };

    const setLight = () => {
        localStorage.setItem("theme", "light");
        document.documentElement.setAttribute("data-theme", "light");
    };

    const storedTheme = localStorage.getItem("theme");

    const prefersDark =
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches;

    const defaultDark =
        storedTheme === "dark" || (storedTheme === null && prefersDark);

    if (defaultDark) {
        setDark();
    }

    const [mode, setMode] = useState(defaultDark ? true : false);

    const toggleTheme = (e) => {
        if (!mode) {
            setDark();
        } else {
            setLight();
        }
        setMode(!mode);
    };
    return (
        <div className="drawerDiv">
            <MenuRoundedIcon
                className="link"
                style={{ fontSize: "1.5rem", margin: 0 }}
                onClick={() => setOpen(true)}
            />
            <Drawer anchor={"right"} open={open} onClose={() => setOpen(false)}>
                <div className="drawer">
                    <a href="/">
                        <p className="link">Home</p>
                    </a>
                    <a href="/compare">
                        <p className="link">Compare</p>
                    </a>
                    <a href="/watchlist">
                        <p className="link">Watchlist</p>
                    </a>
                    <a href="/dashboard">
                        <p className="link">Dashboard</p>
                    </a>
                    <Switch
                        checked={!mode}
                        onClick={(e) => {
                            toggleTheme();
                        }}
                    />
                </div>
            </Drawer>
        </div>
    );
}